import React from 'react';
import { Button, Box, Typography } from '@material-ui/core';
import CustomDialog from '../common/Dialog';
import { useStyles } from './exportIntiated.styles'
interface ExportInitiatedDialogProps {
  openExportInitiatedInfo: boolean;
  handleDialogClose: () => void;
  reportId: string;
}

const ExportInitiatedDialog = (props: ExportInitiatedDialogProps) => {
 const componentClasses = useStyles();
  const { openExportInitiatedInfo, handleDialogClose, reportId } = props;
  const dialogPaperProps = {
    classes: {
      root: componentClasses.dialogPaperPropsRoot
    },
    square: true
  }
  const getTitleContent = () => {
    return (
      <Typography style={{ fontSize: '20px', fontWeight: 'bold' }}>
        Report is Being Generated
      </Typography>
    );
  };

  const getDetailsContent = () => {
    return (
      <Typography style={{ fontSize: '16px' }}>
       Your report is being prepared. You can download it from report tab.
      </Typography>
    );
   
  };

  const handleGoToReports = () => {
    if (window && window.top) {
      const url = `/reports${reportId ? `?reportId=${reportId}` : ''}`;
      window.location.href = url;
    }
  };

  // const handleGoToReports = () => {
  //   history.push('/reports'); // Replace '/reports' with your desired path
  // };

  const getDialogActions = () => {
    return (
      <Box display="flex" width="100%">
    <Button onClick={handleDialogClose} variant="contained" style={{ flex: 1, marginRight: '8px' }}>
      Later
    </Button>
    <Button onClick={handleGoToReports} variant="contained" color="primary" style={{ flex: 1 }}>
      Go To Reports
    </Button>
  </Box>
    );
  };

  return (
    <CustomDialog
      open={openExportInitiatedInfo}
      PaperProps={dialogPaperProps}
      title={getTitleContent()}
      content={getDetailsContent()}
      actions={getDialogActions()}
      handleClose={handleDialogClose}
    ></CustomDialog>
  );
};

export default ExportInitiatedDialog;